import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "emotionCommon" }
const _hoisted_2 = { class: "parameterCommon" }
const _hoisted_3 = { class: "commonSlider" }
const _hoisted_4 = { class: "parameterCommon" }
const _hoisted_5 = { class: "commonSlider" }
const _hoisted_6 = { class: "parameterCommon" }
const _hoisted_7 = { class: "commonSlider" }
const _hoisted_8 = { class: "parameterCommon" }
const _hoisted_9 = { class: "commonSlider" }
const _hoisted_10 = { class: "parameterCommon" }
const _hoisted_11 = { class: "commonSlider" }
const _hoisted_12 = { class: "parameterCommon" }
const _hoisted_13 = { class: "commonSlider" }
const _hoisted_14 = { class: "parameterCommon" }
const _hoisted_15 = { class: "commonSlider" }
const _hoisted_16 = { class: "parameterCommon" }
const _hoisted_17 = { class: "commonSlider" }

import { ref, onMounted,getCurrentInstance } from 'vue'
import slider from '../commonPage/slider.vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'vectorControl',
  emits: ['emoVectorData'],
  setup(__props, { emit: __emit }) {

const emit = __emit

// [喜悦,愤怒,哀伤,恐惧,厌恶,低落,惊喜,平静]
const datalistOne=ref({
    'joy':0,
    'anger':0,
    'grief':0,
    'fear':0,
    'disgust':0,
    'low':0,
    'surprise':0,
    'calm':0,
})
// 
const updataNumjoy=(num:number)=>{
    datalistOne.value.joy=num
    dataProcess()
}
const handleChangeNumjoy=(num:number)=>{
    datalistOne.value.joy=num
    dataProcess()
}
const updataNumanger=(num:number)=>{
    datalistOne.value.anger=num
    dataProcess()
}
const handleChangeNumanger=(num:number)=>{
    datalistOne.value.anger=num
    dataProcess()
}
const updataNumgrief=(num:number)=>{
    datalistOne.value.grief=num
    dataProcess()
}
const handleChangeNumgrief=(num:number)=>{
    datalistOne.value.grief=num
    dataProcess()
}
const updataNumfear=(num:number)=>{
    datalistOne.value.fear=num
    dataProcess()
}
const handleChangeNumfear=(num:number)=>{
    datalistOne.value.fear=num
    dataProcess()
}
const updataNumdisgust=(num:number)=>{
    datalistOne.value.disgust=num
    dataProcess()
}
const handleChangeNumdisgust=(num:number)=>{
    datalistOne.value.disgust=num
    dataProcess()
}
const updataNumlow=(num:number)=>{
    datalistOne.value.low=num
    dataProcess()
}
const handleChangeNumlow=(num:number)=>{
    datalistOne.value.low=num
    dataProcess()
}
const updataNumsurprise=(num:number)=>{
    datalistOne.value.surprise=num
    dataProcess()
}
const handleChangeNumsurprise=(num:number)=>{
    datalistOne.value.surprise=num
    dataProcess()
}
const updataNumcalm=(num:number)=>{
    datalistOne.value.calm=num
    dataProcess()
}
const handleChangeNumcalm=(num:number)=>{
    datalistOne.value.calm=num
    dataProcess()
}

const dataProcess=()=>{
    const dataArr=[datalistOne.value.joy,datalistOne.value.anger,datalistOne.value.grief,datalistOne.value.fear,datalistOne.value.disgust,datalistOne.value.low,datalistOne.value.surprise,datalistOne.value.calm]
    // console.log(dataArr)
    emit('emoVectorData',JSON.stringify(dataArr))
}

return (_ctx: any,_cache: any) => {
  const _component_el_input_number = _resolveComponent("el-input-number")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[8] || (_cache[8] = _createElementVNode("div", { class: "commonTitle" }, " 喜悦", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(slider, {
          min: 0,
          max: 1,
          num: datalistOne.value.joy,
          precision: true,
          class: "sliderStyle",
          onUpdataNum: updataNumjoy
        }, null, 8, ["num"]),
        _createVNode(_component_el_input_number, {
          modelValue: datalistOne.value.joy,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((datalistOne.value.joy) = $event)),
          min: 0,
          max: 1,
          precision: 1,
          step: 0.1,
          "controls-position": "right",
          size: "small",
          onChange: handleChangeNumjoy
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "commonTitle" }, " 愤怒", -1)),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(slider, {
          min: 0,
          max: 1,
          num: datalistOne.value.anger,
          precision: true,
          class: "sliderStyle",
          onUpdataNum: updataNumanger
        }, null, 8, ["num"]),
        _createVNode(_component_el_input_number, {
          modelValue: datalistOne.value.anger,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((datalistOne.value.anger) = $event)),
          min: 0,
          max: 1,
          precision: 1,
          step: 0.1,
          "controls-position": "right",
          size: "small",
          onChange: handleChangeNumanger
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _cache[10] || (_cache[10] = _createElementVNode("div", { class: "commonTitle" }, " 哀伤", -1)),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(slider, {
          min: 0,
          max: 1,
          num: datalistOne.value.grief,
          precision: true,
          class: "sliderStyle",
          onUpdataNum: updataNumgrief
        }, null, 8, ["num"]),
        _createVNode(_component_el_input_number, {
          modelValue: datalistOne.value.grief,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((datalistOne.value.grief) = $event)),
          min: 0,
          max: 1,
          precision: 1,
          step: 0.1,
          "controls-position": "right",
          size: "small",
          onChange: handleChangeNumgrief
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _cache[11] || (_cache[11] = _createElementVNode("div", { class: "commonTitle" }, " 恐惧", -1)),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(slider, {
          min: 0,
          max: 1,
          num: datalistOne.value.fear,
          precision: true,
          class: "sliderStyle",
          onUpdataNum: updataNumfear
        }, null, 8, ["num"]),
        _createVNode(_component_el_input_number, {
          modelValue: datalistOne.value.fear,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((datalistOne.value.fear) = $event)),
          min: 0,
          max: 1,
          precision: 1,
          step: 0.1,
          "controls-position": "right",
          size: "small",
          onChange: handleChangeNumfear
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _cache[12] || (_cache[12] = _createElementVNode("div", { class: "commonTitle" }, " 厌恶", -1)),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(slider, {
          min: 0,
          max: 1,
          num: datalistOne.value.disgust,
          precision: true,
          class: "sliderStyle",
          onUpdataNum: updataNumdisgust
        }, null, 8, ["num"]),
        _createVNode(_component_el_input_number, {
          modelValue: datalistOne.value.disgust,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((datalistOne.value.disgust) = $event)),
          min: 0,
          max: 1,
          precision: 1,
          step: 0.1,
          "controls-position": "right",
          size: "small",
          onChange: handleChangeNumdisgust
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _cache[13] || (_cache[13] = _createElementVNode("div", { class: "commonTitle" }, " 低落", -1)),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(slider, {
          min: 0,
          max: 1,
          num: datalistOne.value.low,
          precision: true,
          class: "sliderStyle",
          onUpdataNum: updataNumlow
        }, null, 8, ["num"]),
        _createVNode(_component_el_input_number, {
          modelValue: datalistOne.value.low,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((datalistOne.value.low) = $event)),
          min: 0,
          max: 1,
          precision: 1,
          step: 0.1,
          "controls-position": "right",
          size: "small",
          onChange: handleChangeNumlow
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _cache[14] || (_cache[14] = _createElementVNode("div", { class: "commonTitle" }, " 惊喜", -1)),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(slider, {
          min: 0,
          max: 1,
          num: datalistOne.value.surprise,
          precision: true,
          class: "sliderStyle",
          onUpdataNum: updataNumsurprise
        }, null, 8, ["num"]),
        _createVNode(_component_el_input_number, {
          modelValue: datalistOne.value.surprise,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((datalistOne.value.surprise) = $event)),
          min: 0,
          max: 1,
          precision: 1,
          step: 0.1,
          "controls-position": "right",
          size: "small",
          onChange: handleChangeNumsurprise
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _cache[15] || (_cache[15] = _createElementVNode("div", { class: "commonTitle" }, " 平静", -1)),
      _createElementVNode("div", _hoisted_17, [
        _createVNode(slider, {
          min: 0,
          max: 1,
          num: datalistOne.value.calm,
          precision: true,
          class: "sliderStyle",
          onUpdataNum: updataNumcalm
        }, null, 8, ["num"]),
        _createVNode(_component_el_input_number, {
          modelValue: datalistOne.value.calm,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((datalistOne.value.calm) = $event)),
          min: 0,
          max: 1,
          precision: 1,
          step: 0.1,
          "controls-position": "right",
          size: "small",
          onChange: handleChangeNumcalm
        }, null, 8, ["modelValue"])
      ])
    ])
  ]))
}
}

})